import { render, staticRenderFns } from "./SmallSearch.vue?vue&type=template&id=58f8d9b4"
import script from "./SmallSearch.vue?vue&type=script&lang=js"
export * from "./SmallSearch.vue?vue&type=script&lang=js"
import style0 from "./SmallSearch.vue?vue&type=style&index=0&id=58f8d9b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports